import crypto from 'crypto';
import getConfigVars from '#utils/get-config-vars';

export default class PreviewSignatureService {
  private readonly secret: string;

  constructor() {
    const { PREVIEW_URL_SECRET_KEY } = getConfigVars();
    this.secret = PREVIEW_URL_SECRET_KEY;
  }

  buildSignature(url: string, expirationDate: Date) {
    const policy = Buffer.from(
      `Url=${url}:Expires:${expirationDate.getTime()}`
    ).toString('base64');

    const signatureData = this.signHmac(policy);

    return Buffer.from(
      JSON.stringify({
        url: url,
        signature: signatureData,
        expirationTimestamp: expirationDate.getTime(),
      })
    ).toString('base64');
  }

  checkSignature(url: string, signature: string) {
    const decodedSignature = JSON.parse(
      Buffer.from(signature, 'base64').toString('utf-8')
    );

    if (
      !decodedSignature.signature ||
      !decodedSignature.expirationTimestamp ||
      !decodedSignature.url
    ) {
      throw new Error('Invalid signature provided');
    }

    const now = new Date();
    const expirationDate = new Date(
      Number(decodedSignature.expirationTimestamp)
    );

    if (now.getTime() > expirationDate.getTime()) {
      throw new Error('Signature expired');
    }

    const currentUrl = decodeURIComponent(url);

    if (currentUrl !== decodedSignature.url) {
      throw new Error('Signature not valid for current url');
    }

    const rSignature = this.buildSignature(url, expirationDate);

    if (rSignature !== signature) {
      throw new Error('Signature expired');
    }
  }

  signHmac(str: string): string {
    const hmac = crypto.createHmac('sha512', this.secret);
    return hmac.update(Buffer.from(str, 'utf-8')).digest('hex');
  }
}
